import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import getDetailsFromRouteselectors from '../GetDetailsFromRoute/selectors';
import selectors from './selectors';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { actions } from '.';

const useStyles = makeStyles((theme) => ({
  summary: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2, 2.5),
  },
}));

const AccountLinkIntentSummary = () => {
  const classes = useStyles();
  const history = useHistory();
  const accountIntent = useSelector(selectors.selectAccountIntent);
  const intentId = useSelector(getDetailsFromRouteselectors.selectIntentId);
  const [stateAccountIntent, setAccountIntentState] = useState(accountIntent);
  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (intentId && !stateAccountIntent) {
      dispatch(actions.getAccountIntentSummary(intentId)).then((response: any) => {
        const { payload, error } = response;
        if (!error && payload.data) {
          const { status } = payload.data;
          if (status === 'Pending') {
            setAccountIntentState(payload.data);
          } else {
            history.push({
              pathname: '/500',
              state: { message: 'Error. Your account has already been linked to your Shift account.' },
            });
          }
        } else {
          history.push({
            pathname: '/500',
            state: { message: 'Error. The page you are trying to access is invalid.' },
          });
        }
      });
    } else if (!accountIntent) {
      history.push({
        pathname: '/500',
        state: { message: 'Sorry, this link is no longer valid' },
      });
    }
  }, [intentId]);

  return (
    <Grid className={classes.summary}>
      <Typography variant='h5'>You must validate you are an authorised contact of the business before proceeding.</Typography>
    </Grid>
  );
};

export default AccountLinkIntentSummary;
